import { Plus } from 'lucide-react';
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom';

type Props={
buttonLinkPath:string,
buttonLabel:string
}

function PrimaryButtonWithIconAdd({buttonLabel,buttonLinkPath}:Props) {
    const {t} = useTranslation();
  return (
        <div className="flex-shrink-0 mt-2 md:mt-0">
        <Link to={buttonLinkPath}
          className="flex capitalize items-center gap-2 px-4 py-2 rounded-[20px] h-[54px] bg-primaryButton text-white font-medium hover:opacity-90 transition whitespace-nowrap"
        >
          <Plus size={16} />
          {t(buttonLabel)}
        </Link>
      </div>
  )
}

export default PrimaryButtonWithIconAdd